import {LoggerLevel} from '@common-lib';

declare const PRODUCTION: any;
declare const LOGER_LEVEL: any;
declare const API_URL: any;
declare const SOCKET_IO_URL: any;
declare const BASE_PATH: any;
declare const DEFAULT_LANGUAGE: any;
declare const DEFAULT_LOCALE: any;
declare const PLUGIN_GOTENEHUS_ON: any;

const getLoggerLevel = () => {
    switch(LOGER_LEVEL) {
        case 'TRACE':
            return LoggerLevel.TRACE;
        case 'DEBUG':
            return LoggerLevel.DEBUG;
        case 'INFO':
            return LoggerLevel.INFO;
        case 'LOG':
            return LoggerLevel.LOG;
        case 'WARN':
            return LoggerLevel.WARN;
        case 'ERROR':
            return LoggerLevel.ERROR;
        case 'OFF':
        default:
            return LoggerLevel.OFF;
    }
}

export const environment = {
    production: PRODUCTION === 'true',
    API_URL: API_URL,
    SOCKET_IO_URL: SOCKET_IO_URL,
    BASE_PATH: BASE_PATH,
    LOG_LEVEL: getLoggerLevel(),
    DEFAULT_LANGUAGE: DEFAULT_LANGUAGE,
    DEFAULT_LOCALE: DEFAULT_LOCALE,
    plugin_gotenehus_on : PLUGIN_GOTENEHUS_ON === 'true'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts